import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { DeleteObject } from "@interfaces/dto/deleteObject.interface";
import { Service } from "@services/service";

@Injectable()
export class InvoiceService extends Service {
	constructor(injector: Injector) {
		super("Invoice", injector);
	}

	// API
	delete(data: DeleteObject) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Delete`, data);
	}

	generateAndPreviewPdf(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GenerateAndPreviewPdf/${id}`, { responseType: "blob" as "json"} );
	}

	getArchived() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/Archived`);
	}

	getBySalesOrderId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetBySalesOrderId/${id}`);
	}

	getDeleted() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/Deleted`);
	}

	getForPart(partId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetForPart/${partId}`);
	}

	getGrid() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetGrid`);
	}

	getGridForInvoice(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetLineItemsGridForInvoice/${id}`);
	}

	getRecent() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/Recent`);
	}

	markCompleted(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/MarkCompleted/${id}`, {});
	}

	markSent(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/MarkSent/${id}`, {});
	}

	updateLineItems(id: number, data: any) {
		return this.http.patch(`${environment.server.apiURL}/${this.endpoint}/UpdateLineItems/${id}`, data);
	}

	updateNotes(id: number, data: any) {
		return this.http.patch(`${environment.server.apiURL}/${this.endpoint}/UpdateNotes/${id}`, data);
	}
}